import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../services/shared.service';
import { FaqService } from '../../services/faq.service';
import { IFaqDto } from '../../interfaces/Faq/ifaq-dto';

@Component({
  selector: 'app-forms',
  templateUrl: './forms.component.html',
  styleUrls: ['./forms.component.css']
})
export class FaqFormsComponent implements OnInit {

  faq: IFaqDto;
  loading = false;

  constructor(private sharedService: SharedService, private faqService: FaqService) { }

  ngOnInit() {
    this.sharedService.reloadUserPrivileges();
    this.loadFaq();
  }

  loadFaq() {
    this.loading = true;
    this.faqService.getFaqByCode('forms').subscribe(result => {
      this.faq = result;
      this.loading = false;
      this.sharedService.showLoadingMessage = false;
    }, error => {
      console.error(error);
      this.loading = false;
      this.sharedService.showLoadingMessage = false;
    });
  }

}
